module.exports = __webpack_public_path__ + "static/media/jiankang_geren_icon.bb0883f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiankang_geren_icon.png
// module id = 409
// module chunks = 0